import { uuid } from 'zl-shared/dist/lib';

import { getOrSetCookie } from '@/shared/cookie';

const DEFAULT_STORAGE_KEY = 'zlDeviceId';

const getDeviceId = (storageKey = DEFAULT_STORAGE_KEY) => {
  const deviceId = localStorage.getItem(storageKey);
  return getOrSetCookie(storageKey, deviceId || (() => `web:${uuid()}`), true);
};

export default getDeviceId;
